import { ErrorPage, useAnalyticsContext } from '@lemonade-hq/nuiza';
import type { FC } from 'react';
import { useCallback } from 'react';
import { PartnerName } from '../../../../../definitions';
import { usePartnerOnboarding } from '../../../queries';
import { Event } from '../../../utils/analytics';
import { redirectToURL } from '../../../utils/helpers';
import { AnimateLogoPair } from '../AnimateLogoPair';
import { PARTNER_NAME_TO_LOGO } from '../consts';
import { RevolutAnimationLayout } from './styles';

const partnerName = PartnerName.Revolut;

export const Revolut: FC = () => {
  const params = new URL(window.location.href).searchParams;
  const dataSourceId = params.get('dataSourceId') ?? '';
  const token = params.get('token') ?? '';
  const { trackEvent } = useAnalyticsContext();
  const { data, isError, isLoading } = usePartnerOnboarding({ partnerName, dataSourceId, token });

  const handleAnimationFinish = useCallback(() => {
    if (typeof data?.url !== 'string') return;

    redirectToURL(data.url);
  }, [data]);

  const handleDOMLoad = useCallback(() => {
    trackEvent(Event.PartnerLoadingPageViewed, { partnerName });
  }, [trackEvent]);

  if (isError) {
    trackEvent(Event.PartnerLoadingPageError, { partnerName });

    return <ErrorPage />;
  }

  return (
    <RevolutAnimationLayout>
      <AnimateLogoPair
        isLoading={isLoading}
        logoComponentOrUrlArray={PARTNER_NAME_TO_LOGO[partnerName]}
        onDOMLoaded={handleDOMLoad}
        onFinish={handleAnimationFinish}
      />
    </RevolutAnimationLayout>
  );
};
